import { HttpClientError } from '../utils/HttpClient'

const QUINCE_API_ERROR_TYPE = 'QuinceApiError'

class QuinceApiError extends Error {
  readonly apiErrorObject: Error | HttpClientError
  readonly data?: Record<string, unknown>
  readonly type = QUINCE_API_ERROR_TYPE

  constructor({
    apiName,
    message,
    error,
    data,
  }: {
    apiName: string
    message: string
    error: Error | HttpClientError
    data?: Record<string, unknown>
  }) {
    super(message)
    this.apiErrorObject = error
    this.data = data
    this.name = apiName
    this.stack = error.stack
  }
}

export function isQuinceApiError(error: QuinceApiError | Error): error is QuinceApiError {
  return 'type' in error && error.type === QUINCE_API_ERROR_TYPE
}

export default QuinceApiError
